import React, { useState, useEffect, useRef } from "react";
import { SelectBox, Img, Button } from "components";
import "react-toastify/dist/ReactToastify.css";
import { BASE_PATH_IMAGE } from "app/constants";

import TableReportDetail from "./TableReportDetail";
import { useGetPartnerQuery, useGetReportDetailMutation } from "app/api1";

const generateYears = () => {
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let year = 2014; year <= currentYear; year++) {
    years.push({ label: year.toString(), value: year.toString() });
  }
  return years;
};

const generateMonths = () => {
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  return monthNames.map((name, index) => ({
    label: name,
    value: (index + 1).toString(),
  }));
};

const months = generateMonths();
const years = generateYears();
const currentYear = new Date().getFullYear();
const currentMonth = new Date().getMonth() + 1;

const methods = [
  { value: "", label: "Semua" },
  { value: "PREMIUM", label: "Premium" },
  { value: "1x", label: "Pembelian 1x" },
  { value: "RENEWAL", label: "Renewal" },
];

const selectDownload = [
  // { value: "pdf", label: "PDF" },
  { value: "excel", label: "Excel" },
];

const ReportDetailProductComponents = () => {
  const users = JSON.parse(localStorage.getItem("user"));
  const idLevel = users.idLevel;
  const tableReportRef = useRef();

  const [filter, setFilter] = useState({
    year: currentYear.toString(),
    month: currentMonth.toString(),
    method: "",
    partner: "",
    uid: users?.id,
  });

  const [getReport, { data, isLoading, reset }] = useGetReportDetailMutation();
  const { data: partners } = useGetPartnerQuery();

  const filteredMonths =
    filter.year === currentYear.toString()
      ? months.filter((month) => parseInt(month.value, 10) <= currentMonth)
      : months;
  const selectedMonth = filteredMonths.find((m) => m.value === filter.month);
  const selectedYear = years.find((y) => y.value === filter.year);
  const selectedMethod = methods.find((m) => m.value === filter.method);

  const handleSelectChange = (selectedOption) => {
    if (tableReportRef.current) {
      const type = selectedOption ? selectedOption : null;
      if (type) {
        tableReportRef.current.handleDownload(type);
      }
    }
  };

  const handleButtonClick = (e) => {
    e.preventDefault();

    reset();
    getReport({
      years: filter.year,
      month: filter.month,
      method: filter.method,
      partner: filter.partner,
      uid: users?.id,
    });
  };

  useEffect(() => {
    getReport({
      years: filter.year,
      month: filter.month,
      method: filter.method,
      partner: filter.partner,
      uid: users?.id,
    });
  }, []);

  return (
    <>
      <div className="bg-white_A700 flex flex-col gap-6 items-start justify-center max-w-full p-[26px] sm:px-5 rounded-bl-[16px] rounded-br-[16px] rounded-tl-none rounded-tr-none w-full">
        <div
          className={
            idLevel === 1 || idLevel === 14
              ? "grid grid-cols-6 gap-3 w-[100%]"
              : "grid grid-cols-6 gap-6 w-[100%]"
          }
        >
          {/* Months */}
          <div className="col-span-3 mdreal:col-span-1 place-items-center">
            <SelectBox
              className="sm:flex-1 font-semibold leading-[normal] text-gray_800 text-left text-sm sm:w-full"
              placeholderClassName="text-gray_800"
              name="frame628297"
              placeholder={selectedMonth ? selectedMonth.label : ""}
              options={filteredMonths}
              getOptionLabel={(e) => (
                <div className="flex items-center">
                  <span>{e.label}</span>
                </div>
              )}
              shape="RoundedBorder6"
              size="sm"
              variant="OutlineGray200"
              value={selectedMonth ? selectedMonth.value : ""}
              onChange={(value) => {
                setFilter({ ...filter, month: value });
              }}
            />
          </div>

          {/* Years */}
          <div className="col-span-3 mdreal:col-span-1 place-items-center">
            <SelectBox
              className="sm:flex-1 font-semibold leading-[normal] text-gray_800 text-left text-sm sm:w-full"
              placeholderClassName="text-gray_800"
              name="zipcode"
              placeholder={selectedYear.label}
              isSearchable={false}
              isMulti={false}
              options={years}
              getOptionLabel={(e) => (
                <div className="flex items-center">
                  <span>{e.value}</span>
                </div>
              )}
              shape="RoundedBorder6"
              size="sm"
              variant="OutlineGray200"
              value={selectedYear ? selectedYear.value : ""}
              onChange={(value) => {
                setFilter({ ...filter, year: value });
              }}
            />
          </div>

          {/* Method */}
          <div className="col-span-3 mdreal:col-span-1 place-items-center">
            <SelectBox
              className="sm:flex-1 font-semibold leading-[normal] text-gray_800 text-left text-sm sm:w-full"
              placeholderClassName="text-gray_800"
              name="frame628351"
              placeholder={selectedMethod.label}
              isSearchable={false}
              isMulti={false}
              onChange={(value) => {
                setFilter({ ...filter, method: value });
              }}
              options={methods?.map((method) => ({
                label: method.label,
                value: method.value,
              }))}
              getOptionLabel={(option) => (
                <div className="flex items-center">
                  <span>{option.label}</span>
                </div>
              )}
              value={selectedMethod ? selectedMethod.value : ""}
              indicator={
                <Img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/img_arrowdown_gray_800.svg"
                  }
                  className="h-6 w-6"
                  alt="arrow_down"
                />
              }
              shape="RoundedBorder6"
              size="sm"
              variant="OutlineGray200"
            />
          </div>

          {/* Partner */}
          {idLevel === 1 || idLevel === 14 ? (
            <div className="col-span-3 mdreal:col-span-1 place-items-center">
              {idLevel === 1 || idLevel === 14 ? (
                <SelectBox
                  className="sm:flex-1 font-semibold leading-[normal] text-gray_800 text-left text-sm sm:w-full max-w-screen-mdreal"
                  placeholderClassName="text-gray_800"
                  name="frame628350"
                  placeholder={"Semua Partner"}
                  isSearchable={false}
                  isMulti={false}
                  options={[
                    { label: "Semua Partner", value: "" },
                    ...(partners?.response?.map((partner) => ({
                      label: partner.partner_name,
                      value: partner.value,
                    })) || []),
                  ]}
                  getOptionLabel={(option) => (
                    <div className="flex items-center">
                      <span>{option.label}</span>
                    </div>
                  )}
                  shape="RoundedBorder6"
                  size="sm"
                  variant="OutlineGray200"
                  onChange={(selectedOption) => {
                    setFilter((prevFilter) => ({
                      ...prevFilter,
                      partner: selectedOption,
                    }));
                  }}
                />
              ) : (
                <></>
              )}
            </div>
          ) : (
            <></>
          )}

          {/* Update button */}
          <div className="col-span-3 mdreal:col-span-1 place-items-center">
            <Button
              className="cursor-pointer flex items-center justify-center min-w-[104px] w-[125px] h-[47px]"
              leftIcon={
                <Img
                  src={BASE_PATH_IMAGE + "img_search_white_a700.svg"}
                  className="mr-2.5"
                  alt="search"
                />
              }
              shape="RoundedBorder8"
              size="md"
              variant="OutlineGray200"
              onClick={handleButtonClick}
            >
              <div className="font-semibold leading-[normal] text-left text-sm text-white_A700 w-[150px]">
                Update
              </div>
            </Button>
          </div>

          {/* Unduh Laporan */}
          {idLevel === 1 || idLevel === 14 ? (
            <>
              <div className="justify-end place-items-center">
                <SelectBox
                  className="sm:flex-1 font-semibold leading-[normal] text-gray_800 text-left text-sm sm:w-full w-full"
                  placeholderClassName="text-gray_800"
                  name="frame628350"
                  placeholder="Unduh Laporan"
                  isSearchable={false}
                  isMulti={false}
                  options={selectDownload}
                  onChange={handleSelectChange}
                  shape="RoundedBorder6"
                  size="sm"
                  variant="OutlineGray200"
                />
              </div>
            </>
          ) : (
            <>
              <div className="col-span-3 mdreal:col-span-1 place-items-center"></div>
              <div className="flex justify-end place-items-center">
                <SelectBox
                  className="sm:flex-1 font-semibold leading-[normal] text-gray_800 text-left text-sm sm:w-full w-full"
                  placeholderClassName="text-gray_800"
                  name="frame628350"
                  placeholder="Unduh Laporan"
                  isSearchable={false}
                  isMulti={false}
                  options={selectDownload}
                  onChange={handleSelectChange}
                  shape="RoundedBorder6"
                  size="sm"
                  variant="OutlineGray200"
                />
              </div>
            </>
          )}
        </div>

        {/* Table */}
        <div className="bg-white_A700 flex flex-col gap-[26px] items-start justify-start w-full overflow-x-auto">
          <TableReportDetail
            tableData={data?.recap_detail || []}
            month={filter.month}
            year={filter.year}
            // setTableData={setTableData}
            // setColumns={setColumns}
            isLoading={isLoading}
            ref={tableReportRef}
          />
        </div>
      </div>
    </>
  );
};

export default ReportDetailProductComponents;
